import router from "@/router"
import { useUserStore } from "@/store/user-store"
import { getToken } from "@common/composables/embed/useEmbedAuth"
import { isEmbeddedContext } from "@common/services/embed-service"
import { createEnsureEmbedded, createEnsureNotEmbedded, ensureEmbedAuthenticated } from "@common/router/embed-guards"
import { NavigationGuard, RouteLocationNormalized, LocationQueryValue } from "vue-router"

const LOGIN_PASSTHROUGH_QUERY_KEYS = ["userType", "for", "oe"] as const

function buildLoginQuery(to: RouteLocationNormalized): Record<string, LocationQueryValue | LocationQueryValue[]> {
  const query: Record<string, LocationQueryValue | LocationQueryValue[]> = { redirectedFromPath: to.fullPath }
  for (const key of LOGIN_PASSTHROUGH_QUERY_KEYS) {
    const value = to.query[key]
    if (value !== undefined) query[key] = value
  }
  return query
}

export const ensureIsAnonymous: NavigationGuard = (_to, _from, _next) => {
  const isLoggedIn = useUserStore().isLoggedIn
  if (isLoggedIn) {
    router.push({ name: "home" }).then()
    return false
  }

  return true
}

export const ensureIsAuthenticated: NavigationGuard = (to, _from, _next) => {
  const isLoggedIn = useUserStore().isLoggedIn

  if (!isLoggedIn) {
    router.push({ name: "login", query: buildLoginQuery(to) }).then()
    return false
  }

  return true
}

export const ensureIsAuthenticatedOrEmbed: NavigationGuard = (to, _from, _next) => {
  if (isEmbeddedContext() && getToken()) return true

  const isLoggedIn = useUserStore().isLoggedIn
  if (!isLoggedIn) {
    router.push({ name: "login", query: buildLoginQuery(to) }).then()
    return false
  }

  return true
}

export const ensureEmbedded = createEnsureEmbedded(() => router)
export const ensureNotEmbedded = createEnsureNotEmbedded(() => router, "embed-employee-dashboard")
export { ensureEmbedAuthenticated }
